module.exports = __webpack_public_path__ + "static/img/banner002.2a554e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/financialAudit/banner002.png
// module id = 4r7/
// module chunks = 1